import { MapboxMap, PopupProps } from 'react-map-gl';

import type { MapMarkerOptions } from './Map.types';

const MARKER_WIDTH = 18;
const MARKER_HEIGHT = 26;
const MARKER_RADIUS = MARKER_WIDTH / 2;
const LINEAR_OFFSET = 25;

export const POPUP_OFFSETS: PopupProps['offset'] = {
  top: [0, 0],
  'top-left': [0, 0],
  'top-right': [0, 0],
  bottom: [0, -MARKER_HEIGHT],
  'bottom-left': [LINEAR_OFFSET, (MARKER_HEIGHT - MARKER_RADIUS + LINEAR_OFFSET) * -1],
  'bottom-right': [-LINEAR_OFFSET, (MARKER_HEIGHT - MARKER_RADIUS + LINEAR_OFFSET) * -1],
  left: [MARKER_RADIUS, (MARKER_HEIGHT - MARKER_RADIUS) * -1],
  right: [-MARKER_RADIUS, (MARKER_HEIGHT - MARKER_RADIUS) * -1],
};

export const markerSvg = (options: MapMarkerOptions) =>
  `<svg width="${MARKER_WIDTH}" height="${MARKER_HEIGHT}" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 .5A8.744 8.744 0 0 0 .25 9.25C.25 15.813 9 25.5 9 25.5s8.75-9.688 8.75-16.25A8.744 8.744 0 0 0 9 .5Zm0 11.875a3.126 3.126 0 0 1 0-6.25 3.126 3.126 0 0 1 0 6.25Z" fill="${options.fill}" fill-opacity="${options.fillOpacity}"/></svg>`;

export const addMarkersToMap = (markers: MapMarkerOptions[], map: MapboxMap) => {
  markers.forEach((marker) => {
    const img = new Image(MARKER_WIDTH * 2, MARKER_HEIGHT * 2);
    img.onload = () => {
      map.addImage(marker.variant, img, { pixelRatio: 2 });
    };
    img.src = `data:image/svg+xml;utf8,${encodeURIComponent(markerSvg(marker))}`;
  });
};

export const filterPotentialSupplier = ['==', ['get', 'relationship'], 'potential'];
export const filterProvenSupplier = ['==', ['get', 'relationship'], 'proven'];

export const jitterData = (data: GeoJSON.FeatureCollection<GeoJSON.Geometry>) => {
  const rad_Earth = 6378.16;
  const one_degree = (2 * Math.PI * rad_Earth) / 360;
  const one_km = 1 / one_degree;

  const randomInRange = (from: number, to: number, fixed?: number) => {
    return Number((Math.random() * (to - from) + from).toFixed(fixed ?? 10)) * 1; // nosemgrep @nodejs_scan/javascript-crypto-rule-node_insecure_random_generator
  };

  const jitter = (coordinates: number[], kms: number, fixed?: number) => {
    return [
      randomInRange(coordinates[0] - kms * one_km, coordinates[0] + kms * one_km, fixed),
      randomInRange(coordinates[1] - kms * one_km, coordinates[1] + kms * one_km, fixed),
    ];
  };

  const transformedFeatures = data.features.map((p) => ({
    ...p,
    geometry: { type: 'Point', coordinates: jitter((p.geometry as any).coordinates, 0.01) },
  }));

  return { ...data, transformedFeatures };
};
